module.exports = __webpack_public_path__ + "img/egg3.95916f33.png";